'use strict'
import 'babel-polyfill'
import ServiceExec from '@/common/utils/ServiceExec'
import {forEach} from 'lodash'

/**
 * 공통 API Service
 * @class CommonSvc
 */
class CommonSvc extends ServiceExec {

  /**
   * 디바이스 앱 버전 가져오기
   * @param params
   */
  getAppVersion(params = {}) {
    return this.post(`/common/getAppVersion`, params)
    .then(response => {
      return response.data
    })
  }

  /**
   * 휴대폰 인증코드 발송
   *
   * @param params
   * @returns {Promise<any> | Q.Promise<any> | * | PromiseLike<any>}
   */
  sendPhoneAuth(params = {}) {
    const formData = new FormData()
    forEach(params, function (value, key) {
      formData.append(key, value)
    })
    return this.post(`/common/sendAuthCode`, formData)
    .then(res => res.data)
  }

  /**
   * 휴대폰 인증코드 조회
   *
   * @param params
   * @returns {Promise<any> | Q.Promise<any> | * | PromiseLike<any>}
   */
  confirmPhoneAuthCode(params = {}) {
    const formData = new FormData()
    forEach(params, function (value, key) {
      formData.append(key, value)
    })
    return this.post(`/common/verifyAuthCode`, formData)
    .then(res => res.data)
  }

  /**
   * 파일업로드
   * @param params
   */
  uploadFile(params = {}) {
    const formData = new FormData()
    forEach(params, function (value, key) {
      formData.append(key, value)
    })
    return this
    .multiPost(`/common/uploadFile`, formData)
    .then(response => {
      return response.data
    })
  }

  getAgencyList(params) {
    return this.queryPost(`/common/getAgencyList`, params)
    .then(res => res.data)
  }
}

export default new CommonSvc()
